module.exports = {
    BASE_URL: 'https://cms.nhf.org.bd/api/',
    MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s'
}
